import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";

export const StyledEnrichmentInstructionsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 32px;
    & ul {
        margin-left: 16px;
    }
    padding: 0 44px;
`;

export const StyledListItem = styled.li`
    ${setFontVariant("body2", colorsPalettes.carbon[400])}
`;

export const StyledTemplateLink = styled.a`
    ${setFontVariant("subtitle2", colorsPalettes.blue[400])};
    cursor: pointer;
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;
